import React from 'react'

export default function Departments() {
    return (
        <div>
            THis is Departments part of quick info
        </div>
    )
}
